import { render, staticRenderFns } from "./PasswordAndPasswordRepeatBlock.vue?vue&type=template&id=4cd522fe&scoped=true&"
import script from "./PasswordAndPasswordRepeatBlock.vue?vue&type=script&lang=js&"
export * from "./PasswordAndPasswordRepeatBlock.vue?vue&type=script&lang=js&"
import style0 from "./PasswordAndPasswordRepeatBlock.vue?vue&type=style&index=0&id=4cd522fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd522fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
